import {ReactElement, useEffect, useRef} from 'react';
import {startHeroWaveAnimation} from './HeroWaveAnimation';

export function HeroWaveBackground(): ReactElement {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    if (!canvas) {
      return undefined;
    }

    return startHeroWaveAnimation(canvas);
  }, []);

  return <canvas ref={canvasRef} className="hero-wave-background" aria-hidden="true" />;
}
